<template>
  <div>
    <px-view-header title="Produtos" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-listagem-produtos-header :on-click-refresh="onClickRefresh"
                                 :on-change-filter="onChangeFilter"/>
    <px-lista-produtos :produtos="produtos"
                       :loading="loading"
                       :on-change-options="onChangeOptions"
                       :options-list="optionsList"
                       :footer-options="footerOptions"
                       @remove="onRemove"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-produtos/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import ListaProdutos from './listagem/ProdutosList.vue';
import ListagemProdutosHeader from './listagem/ProdutosListHeader.vue';
import ProdutoService from './service/produtos-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      empresa: null,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Meus produtos' },
      ],
      produtos: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemProdutos', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemProdutos', {
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getProdutos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getProdutos();
    },
    onClickRefresh() {
      this.getProdutos();
    },
    onRemove(item) {
      this.loading = true;
      ProdutoService.remover(item.id)
        .then(() => {
          this.$toast('Produto removido com sucesso', { color: 'success' });
          this.getProdutos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getProdutos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return ProdutoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.produtos = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxListaProdutos: ListaProdutos,
    pxListagemProdutosHeader: ListagemProdutosHeader,
  },
};
</script>
